<header class="emerson-header">
  <img src="/assets/logo.png" class="emerson-logo" alt="Emerson Logo">
  <span class="emerson-title">{{ title }}</span>
</header>
<div>
  <router-outlet></router-outlet>
</div>
